
import CompanyActions from "./CompanyActions";
import CompanyMutations from "./CompanyMutations";
import CompaniesService from "@/services/common/CompaniesService";

const state = CompaniesService.EmptyCompanyStateFactory();

const { actions } = CompanyActions;

const { mutations } = CompanyMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	mutations,
};
